module.exports = __webpack_public_path__ + "img/empty-photo.d93b85d9.svg";